"use strict";

var _taggedTemplateLiteral = require("/Users/alecresende/code/visual-sampler/sequencer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _templateObject;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RESOLVE_ENS_FROM_ADDRESS_QUERY = void 0;

var graphql_request_1 = require("graphql-request");

exports.RESOLVE_ENS_FROM_ADDRESS_QUERY = graphql_request_1.gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  fragment DomainResolvedPart on Domain {\n    name\n    labelName\n    labelhash\n    resolvedAddress {\n      id\n    }\n    resolver {\n      id\n    }\n  }\n  query resolveNames($addresses: [String!]) {\n    domains(where: { resolvedAddress_in: $addresses }) {\n      ...DomainResolvedPart\n    }\n  }\n"])));